import {
  Box,
  Button,
  Center,
  Heading,
  Link,
  SimpleGrid,
} from "@chakra-ui/react";
import ProductCardVerticalCenterItem from "@modules/Layout/components/ProductCardVerticalCenterItem";
import ResponsiveContainer from "@modules/Layout/components/ResponsiveContainer";
import React from "react";
import useProductDetailPageAttrQuery from "../hooks/useProductDetailPageAttrQuery";

const RelatedProduct = () => {
  const { data: result } = useProductDetailPageAttrQuery();
  const { relatedProducts } = result!.data.attributes;

  if (!relatedProducts || relatedProducts.length === 0) {
    return (
      <Center my={10}>
        <Heading as="h2" textAlign={{ md: "center" }} mb={10}>
          No related products
        </Heading>
      </Center>
    );
  }

  return (
    <ResponsiveContainer>
      <Box maxW="2xl" mx="auto">
        <Heading as="h1" textAlign={{ md: "center" }} mb={10}>
          Related Products
        </Heading>
      </Box>

      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 4 }}
        spacing={4}
        flex={1}
        my={10}
        display={{ base: "block", lg: "flex" }}
        overflowX={{ base: "scroll", lg: "hidden" }}
        whiteSpace={{ base: "nowrap", lg: "normal" }}
        css={{
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          "&::-webkit-scrollbar": {
            width: "0",
            height: "0",
          },
        }}
      >
        {relatedProducts.map((item, index) => {
          const { name, description, label, slug, image, is_new } = item ?? {};

          const dataItem = {
            name,
            description,
            label,
            slug: `products/${slug}`,
            image: {
              data: {
                id: index,
                attributes: { ...image },
              },
            },
            isNew: is_new,
          };
          return (
            <Box
              key={index}
              width={{
                base: relatedProducts.length === 1 ? "100%" : "80%",
                sm: "45%",
                md: "45%",
                lg: "25%",
              }}
              display={"inline-block"}
              whiteSpace={"normal"}
              marginRight={{ base: 4, lg: 0 }}
            >
              <ProductCardVerticalCenterItem item={dataItem} />
            </Box>
          );
        })}
      </SimpleGrid>

      <Center my={10}>
        <Link href={"/request-a-quote"}>
          <Button variant={"primary"} px={"40px"}>
            Request a quote
          </Button>
        </Link>
      </Center>
    </ResponsiveContainer>
  );
};

export default RelatedProduct;
